import { Box } from "@mui/material";
import _ from "lodash";
import { Children, cloneElement, isValidElement, useState } from "react";

const AccordionGroup = ({ children, isMultipleOpen = true, styles }) => {
  const [accordionStatus, setAccordionStatus] = useState({
    columns: true,
    filter: false,
    sort: false,
  });
  const childrenWithExtraProps = Children.map(children, (child) => {
    if (isValidElement(child)) {
      const { title } = child.props;
      const isOpen = accordionStatus[title];
      return cloneElement(child, {
        isMultipleOpen,
        isOpen,
        toggle: () => {
          setAccordionStatus((prevAccordionStatus) => {
            const newStatus = isMultipleOpen
              ? { ...prevAccordionStatus, [title]: !isOpen }
              : {
                  ..._.mapValues(prevAccordionStatus, () => false),
                  [title]: !isOpen,
                };
            return newStatus;
          });
        },
      });
    }
    return child;
  });
  return <Box sx={{ ...styles }}>{childrenWithExtraProps}</Box>;
};

export default AccordionGroup;
